// Склонение по числу: plural(5, ['заказ', 'заказа', 'заказов']) → 'заказов'.
// «4 клиентов · 4 складов» читалось с ошибкой — подписи к числам склоняем.
export function plural(n, [one, few, many]) {
  const a = Math.abs(Number(n) || 0) % 100;
  const b = a % 10;
  if (a > 10 && a < 20) return many;
  if (b > 1 && b < 5) return few;
  if (b === 1) return one;
  return many;
}

// Число с подписью: pluralN(3, ['заказ', 'заказа', 'заказов']) → '3 заказа'
export function pluralN(n, forms) {
  return `${Number(n || 0).toLocaleString('ru-RU')} ${plural(n, forms)}`;
}
